import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    nav_shop: "Shop",
    nav_categories: "Categories",
    nav_track: "Track Order",
    nav_account: "Account",
    nav_login: "Sign in",
    nav_logout: "Sign out",
    nav_admin: "Admin",
    cart: "Cart",
    wishlist: "Wishlist",
    search_placeholder: "Search products…",
    home_hero_eyebrow: "Made for the Netherlands",
    home_hero_title: "Considered objects for everyday rituals.",
    home_hero_sub: "Bilingual NL / EN store with iDEAL, PostNL & free returns. Designed in Amsterdam, shipped fast across the Netherlands.",
    home_hero_cta: "Explore the store",
    home_hero_secondary: "Why us",
    home_featured: "Featured",
    home_bestsellers: "Best sellers",
    home_new: "New arrivals",
    home_reviews: "From our customers",
    home_faq: "Frequently asked",
    newsletter_title: "Quiet updates. No spam.",
    newsletter_sub: "Once a month, get curated arrivals and member-only codes.",
    newsletter_cta: "Subscribe",
    add_to_cart: "Add to cart",
    out_of_stock: "Out of stock",
    related: "You may also like",
    reviews: "Reviews",
    write_review: "Write a review",
    free_ship_nl: "Free shipping in NL from €50",
    pay_secure: "Secure payments — iDEAL, Klarna, Card",
    returns: "30-day returns",
    rating: "Rated 4.9 / 5",
    cart_empty: "Your cart is empty.",
    continue_shopping: "Continue shopping",
    subtotal: "Subtotal",
    shipping: "Shipping",
    discount: "Discount",
    payment_fee: "Payment fee",
    vat_incl: "VAT included",
    total: "Total",
    checkout: "Checkout",
    one_page_checkout: "One-page checkout",
    contact: "Contact",
    address: "Shipping address",
    payment: "Payment",
    place_order: "Place order",
    apply: "Apply",
    discount_code: "Discount code",
    track_title: "Track your order",
    track_code: "Tracking code",
    track_email: "Email (optional)",
    track_lookup: "Look up",
    filter_price: "Price",
    filter_category: "Category",
    sort_by: "Sort by",
    sort_newest: "Newest",
    sort_price_asc: "Price: Low to high",
    sort_price_desc: "Price: High to low",
    sort_rating: "Top rated",
    cookie_message: "We use essential cookies to make our site work, and analytics cookies to improve it. You can adjust your preferences.",
    cookie_accept: "Accept all",
    cookie_essential: "Essential only",
    learn_more: "Learn more",
    by_signing_up: "By continuing you accept our Terms & Privacy.",
    sign_up: "Create account",
    sign_in: "Sign in",
    google_continue: "Continue with Google",
    or: "or",
    email: "Email",
    password: "Password",
    name: "Full name",
    yourname: "Your name",
    admin_dashboard: "Admin dashboard",
    revenue: "Revenue",
    orders: "Orders",
    customers: "Customers",
    products: "Products",
    low_stock: "Low stock",
    no_account: "No account yet?",
    have_account: "Already have an account?",
    legal_privacy: "Privacy Policy",
    legal_terms: "Terms & Conditions",
    legal_returns: "Returns & Refunds",
    faq: "FAQ",
    contact_us: "Contact us",
    home: "Home",
  },
  nl: {
    nav_shop: "Winkel",
    nav_categories: "Categorieën",
    nav_track: "Volg bestelling",
    nav_account: "Account",
    nav_login: "Inloggen",
    nav_logout: "Uitloggen",
    nav_admin: "Beheer",
    cart: "Winkelmand",
    wishlist: "Verlanglijst",
    search_placeholder: "Producten zoeken…",
    home_hero_eyebrow: "Gemaakt voor Nederland",
    home_hero_title: "Doordachte objecten voor dagelijkse rituelen.",
    home_hero_sub: "Tweetalige NL / EN winkel met iDEAL, PostNL en gratis retouren. Ontworpen in Amsterdam, snel geleverd in heel Nederland.",
    home_hero_cta: "Bekijk de winkel",
    home_hero_secondary: "Waarom wij",
    home_featured: "Uitgelicht",
    home_bestsellers: "Bestsellers",
    home_new: "Nieuw binnen",
    home_reviews: "Van onze klanten",
    home_faq: "Veelgestelde vragen",
    newsletter_title: "Rustige updates. Geen spam.",
    newsletter_sub: "Eén keer per maand: nieuwe aanwinsten en exclusieve codes.",
    newsletter_cta: "Inschrijven",
    add_to_cart: "In winkelmand",
    out_of_stock: "Niet op voorraad",
    related: "Mogelijk vind je dit ook leuk",
    reviews: "Beoordelingen",
    write_review: "Schrijf een beoordeling",
    free_ship_nl: "Gratis verzending in NL vanaf €50",
    pay_secure: "Veilig betalen — iDEAL, Klarna, Kaart",
    returns: "30 dagen retour",
    rating: "Gewaardeerd met 4.9 / 5",
    cart_empty: "Je winkelmand is leeg.",
    continue_shopping: "Verder winkelen",
    subtotal: "Subtotaal",
    shipping: "Verzending",
    discount: "Korting",
    payment_fee: "Betaalkosten",
    vat_incl: "BTW inbegrepen",
    total: "Totaal",
    checkout: "Afrekenen",
    one_page_checkout: "Afrekenen op één pagina",
    contact: "Contact",
    address: "Verzendadres",
    payment: "Betaling",
    place_order: "Bestelling plaatsen",
    apply: "Toepassen",
    discount_code: "Kortingscode",
    track_title: "Volg je bestelling",
    track_code: "Trackingcode",
    track_email: "E-mail (optioneel)",
    track_lookup: "Opzoeken",
    filter_price: "Prijs",
    filter_category: "Categorie",
    sort_by: "Sorteer op",
    sort_newest: "Nieuwste",
    sort_price_asc: "Prijs: laag naar hoog",
    sort_price_desc: "Prijs: hoog naar laag",
    sort_rating: "Best beoordeeld",
    cookie_message: "Wij gebruiken essentiële cookies om onze site te laten werken, en analytische cookies om deze te verbeteren. Je kunt je voorkeuren aanpassen.",
    cookie_accept: "Alles accepteren",
    cookie_essential: "Alleen essentieel",
    learn_more: "Meer info",
    by_signing_up: "Door door te gaan accepteer je onze Voorwaarden en Privacy.",
    sign_up: "Account aanmaken",
    sign_in: "Inloggen",
    google_continue: "Doorgaan met Google",
    or: "of",
    email: "E-mail",
    password: "Wachtwoord",
    name: "Volledige naam",
    yourname: "Je naam",
    admin_dashboard: "Beheer dashboard",
    revenue: "Omzet",
    orders: "Bestellingen",
    customers: "Klanten",
    products: "Producten",
    low_stock: "Lage voorraad",
    no_account: "Nog geen account?",
    have_account: "Heb je al een account?",
    legal_privacy: "Privacybeleid",
    legal_terms: "Algemene voorwaarden",
    legal_returns: "Retouren & restituties",
    shipping_policy: "Verzendbeleid",
    about_us: "Over ons",
    faq: "Veelgestelde vragen",
    contact_us: "Contact",
    home: "Home",
  },
};

const I18nCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "nl");
  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (k) => dict[lang]?.[k] || dict.en[k] || k;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
